// extracted by mini-css-extract-plugin
module.exports = {"element":"Heading3_element__39_Rs"};